module.exports = __webpack_public_path__ + "static/img/ilustra-empty-search.c4df457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilustra-empty-search.png
// module id = TqIc
// module chunks = 0